import { CalendarEventOccurrenceTarget } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChoiceDialog } from 'shared/dialogs/choice';

export type EventApplyToOccurrencesDialogProps = {
  onSelect: (occurrenceTarget: CalendarEventOccurrenceTarget) => void;
  onClose: () => void;
};

// Binds the calendar-event copy onto the shared prompt; both the save path and the drag
// path ask the same question, so neither owns the wording.
export const EventApplyToOccurrencesDialog: React.FC<
  EventApplyToOccurrencesDialogProps
> = ({ onSelect, onClose }) => {
  const { t } = useTranslation();

  const onSingle = () => onSelect(CalendarEventOccurrenceTarget.Single);
  const onThisAndFuture = () =>
    onSelect(CalendarEventOccurrenceTarget.ThisAndFuture);
  const onSeries = () => onSelect(CalendarEventOccurrenceTarget.Series);

  return (
    <ChoiceDialog
      open
      abovePopups
      title={t('forms.event.occurrence-target.title')}
      message={t('forms.event.occurrence-target.description')}
      primaryLabel={t('forms.event.occurrence-target.single')}
      tertiaryLabel={t('forms.event.occurrence-target.this-and-future')}
      secondaryLabel={t('forms.event.occurrence-target.series')}
      onPrimary={onSingle}
      onTertiary={onThisAndFuture}
      onSecondary={onSeries}
      onCancel={onClose}
    />
  );
};
